import React, { useState, useEffect } from 'react';
import './Login.css';

const Login = ({ onLogin, auth }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [lockCountdown, setLockCountdown] = useState(null);

  useEffect(() => {
    let interval;
    if (auth.isLocked && auth.lockUntil) {
      interval = setInterval(() => {
        const remaining = auth.lockUntil - Date.now();
        if (remaining <= 0) {
          clearInterval(interval);
          setLockCountdown(null);
          window.location.reload(); // Recargar para limpiar el estado de bloqueo
        } else {
          setLockCountdown(Math.ceil(remaining / 1000));
        }
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [auth.isLocked, auth.lockUntil]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Pequeña demora para simular procesamiento
    setTimeout(() => {
      const result = auth.login(password);
      
      if (result.success) {
        onLogin(true);
      } else {
        setError(result.message);
      }
      
      setIsLoading(false);
    }, 500);
  };

  if (auth.isLocked) {
    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">
            <h2>🔒 Cuenta Bloqueada</h2>
            <p>Demasiados intentos fallidos</p>
          </div>

          <div className="lockout-message">
            <p>Por seguridad, su cuenta ha sido bloqueada temporalmente.</p>
            <p className="countdown">
              Tiempo restante: {lockCountdown ? `${Math.floor(lockCountdown / 60)}:${(lockCountdown % 60).toString().padStart(2, '0')}` : 'Calculando...'}
            </p>
          </div>

          <div className="login-footer">
            <p>Medida de seguridad activada</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>Acceso al Panel de Control</h2>
          <p>Ingrese la contraseña para continuar</p>
          {auth.loginAttempts > 0 && (
            <p className="attempts-warning">
              Intentos fallidos: {auth.loginAttempts} de {auth.MAX_ATTEMPTS}
            </p>
          )}
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="input-group">
            <label htmlFor="password">Contraseña:</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Ingrese la contraseña"
              required
              autoComplete="current-password"
              className="password-input"
              disabled={isLoading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            disabled={isLoading || !password}
            className="login-button"
          >
            {isLoading ? 'Verificando...' : 'Acceder'}
          </button>
        </form>

        <div className="login-footer">
          <p>Sistema seguro de acceso • {new Date().getFullYear()}</p>
        </div>
      </div>
    </div>
  );
};

export default Login;